import { lazy, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { IconaTutorial } from '@/components/tutorial/IconaTutorial';
import { chiaveTutorialVisto } from '@/lib/storage';
import { senzaTutorialRichiesto, tutorialRichiesto } from '@/lib/burraco/tutorialRichiesto';

/**
 * Il livello arriva SOLO da qui, con `lazy()` e l'annotazione PURE (senza, `lazy(...)` resta nell'entry: misurato dal solitario, `components/solitario/IconaTutorial.tsx`): il suo chunk, col JSON
 * della mano di prova, si scarica quando si apre. Il Burraco e` dietro il flag LETTERALE (`HubSections`), quindi non esce in produzione.
 */
const TutorialBurraco = /*#__PURE__*/ lazy(() => import('./TutorialBurraco').then((m) => ({ default: m.TutorialBurraco })));

/**
 * L'ICONA «Come si gioca» della Hub del Burraco (zona comune `IconaTutorial`). Si apre da sola con `?tutorial=1` (da «Prova tu» e dalle Impostazioni del tavolo vero), letto UNA volta al montaggio e
 * SUBITO TOLTO dall'URL con un `replace` del router: una Hub rimontata (cambio gioco e ritorno) non riapre il tutorial da sola.
 * La monta la Hub, MAI un tavolo vivo (`tools/verify-tutorial.ts`).
 */
export function IconaTutorialBurraco() {
  const { t } = useTranslation('burraco');
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const [richiesto] = useState(() => tutorialRichiesto(search));
  const tolto = useRef(false);
  useEffect(() => {
    if (!richiesto || tolto.current) return;
    tolto.current = true;
    void navigate({ pathname, search: senzaTutorialRichiesto(search), hash }, { replace: true });
  }, [richiesto, navigate, pathname, search, hash]);
  return <IconaTutorial Livello={TutorialBurraco} chiave={chiaveTutorialVisto('burraco')} nome={t('tutorial.comeSiGioca')} nuovo={t('tutorial.comeSiGiocaNuovo')} apriAllAvvio={richiesto} />;
}
